import { createContext, useContext } from 'react';
/**给集成应用使用的context */
export const AccessPermissionContext = createContext(false);
export const useAccessPermission = () => useContext(AccessPermissionContext);
